<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light">
    <!-- Alert -->
    <div>
      <v-alert :type="alert_type" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Alert End -->
    <!-- Title -->
    <HeaderComponent :headerTitle="headerText" :router-link="{ name: 'Aireports' }" :router-link-text="'AI Discrepancy Report'" :return-condition="true" :component-name="item_tagNumber" />
    <!-- Title end -->
    <!-- Search -->
    <!-- <v-card-title>
      <v-row>
        <v-col cols="2" sm="2">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="search_style" outlined></v-text-field>
        </v-col>
      </v-row>
    </v-card-title> -->
    <!-- Data table -->
    <v-layout column>
      <v-card class="v-card-100" v-for="(sideDataArray, sideName) in ai_discrepancy_data" :key="sideName">
        <v-row v-for="(sideData, index) in sideDataArray" :key="index" class="mb-3  item-card">
          <!-- sides -->
          <v-col cols="2" class="sides">
            <ul class="list-type-none">
              <li class="mb-2 content-header">{{ sideName }}</li>
              <li class="mb-2 match-head">
                Match Status:
                <span :style="{ color: sideData.match_status ? 'green' : 'red' }">
                  {{ sideData.match_status ? 'Yes' : 'No' }}
                </span>
              </li>
            </ul>
            <ul class="list-type-none">
              <li class="item-defects">Human:</li>
              <li v-if="sideData.human_identified">
                <ul class="list-type-disk">
                  <li v-if="sideData.human_identified.defects.length === 0" class="na-style">NA</li>
                  <li v-else v-for="defect in sideData.human_identified.defects" :key="defect" class="item-defects">{{ defect }}</li>
                </ul>
              </li>
              <li v-else >
                <span class="na-style">NA</span>
              </li>
              <li class="item-defects">AI:</li>
              <li v-if="sideData.ai_identified">
                <ul class="list-type-disk">
                  <li v-if="sideData.ai_identified.defects.length ===0" class="na-style">NA</li>
                  <li v-else v-for="defect in sideData.ai_identified.defects" :key="defect" class="item-defects">{{ defect }}</li>
                </ul>
              </li>
              <li v-else>
                <span class="na-style">NA</span>
              </li>
            </ul>
          </v-col>
          <!-- source link -->
          <v-col cols="3" class="d-flex">
            <v-col cols="6" class="p-0">
              <v-img v-if="sideData.orignal_image_url" :src="sideData.orignal_image_url" contain class="image"></v-img>
              <span class="na-style" v-else>NA</span>
            </v-col>
            <v-col cols="6">
              <ul class="list-type-none">
                <li class="mb-2 content-header">Source Link <br> Image</li>
                <li class="mb-2 sides-title">{{ sideName }}</li>
              </ul>
            </v-col>
          </v-col>
          <!-- human identified -->
          <v-col cols="3" class="d-flex" v-if="sideData.human_identified">
            <v-col cols="6" class="p-0">
              <v-img v-if="sideData.human_identified.image_url[0]" :src="sideData.human_identified.image_url[0]" contain class="image"></v-img>
              <span class="na-style" v-else>NA</span>
            </v-col>
            <v-col cols="6">
              <ul class="list-type-none">
                <li class="mb-2 content-header">Human Identified</li>
                <li class="mb-2 sides-title">{{ sideName }}</li>
                <li>
                  <ul class="list-type-disk">
                    <li v-if="sideData.human_identified.defects.length === 0" class="na-style">NA</li>
                    <li v-else v-for="defect in sideData.human_identified.defects" :key="defect" class="item-defects">{{ defect }}</li>
                  </ul>
                </li>
              </ul>
            </v-col>
          </v-col>
          <v-col cols="3" class="d-flex" v-else>
            <v-col cols="6" class="p-0">
              <v-img v-if="sideData.human_identified.image_url[0]" :src="sideData.human_identified.image_url[0]" contain class="image"></v-img>
              <span class="na-style" v-else>NA</span>
            </v-col>
            <v-col cols="6">
              <ul class="list-type-none">
                <li class="mb-2 content-header">Human Identified</li>
                <li class="na-style">NA</li>
              </ul>
            </v-col>
          </v-col>
          <!-- ai identified -->
          <v-col cols="3" class="d-flex" v-if="sideData.ai_identified">
            <v-col cols="6" class="p-0">
              <v-img v-if="sideData.ai_identified.image_url" :src="sideData.ai_identified.image_url" contain class="image"></v-img>
              <span v-else class="na-style">NA</span>
            </v-col>
            <v-col cols="6">
              <ul class="list-type-none">
                <li class="mb-2 content-header">AI Identified</li>
                <li class="mb-2 sides-title">{{ sideName }}</li>
                <li>
                  <ul class="list-type-disk">
                    <li v-if="sideData.ai_identified.defects.length === 0" class="na-style">NA</li>
                    <li v-else v-for="defect in sideData.ai_identified.defects" :key="defect" class="item-defects">{{ defect }}</li>
                  </ul>
                </li>
              </ul>
            </v-col>
          </v-col>
          <v-col cols="3" class="d-flex" v-else>
            <v-col cols="6" class="p-0">
              <span class="na-style">NA</span>
            </v-col>
            <v-col cols="6">
              <ul class="list-type-none">
                <li class="mb-2 content-header">AI Identified</li>
                <li class="na-style">NA</li>
              </ul>
            </v-col>
          </v-col>
        </v-row>
      </v-card>
    </v-layout>
    <!-- Data table end -->
  </v-card>
</template>

<script>
  import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";

  export default {
    data() {
      return {
        headerText: "AI Discrepancy Report",
        loading: true,
        alert: false,
        alert_type: "",
        alert_message: "",
        search_tag: [],
        selected: "",
        search: "",
        sideData: [],
        ai_discrepancy_data: {},
      };
    },
    components: {
      HeaderComponent,
    },
    async created() {
      const item_detail = this.$store.state.lotIds;
      this.item_detail = parseInt(item_detail);
      const item_tagNumber = this.$store.state.action;
      this.item_tagNumber = item_tagNumber
      this.getdata();
    },
    methods: {
      getdata() {
        this.$http.secured
          .get(`/api/v1/inventory_grading_details/${this.item_detail}`)
          .then((response) => {
            if (response.data) {
              this.ai_discrepancy_data = response.data.ai_discrepancy_data;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
    },
};
</script>
<style>
  .sides{
    background: #E4F1FF;
    border-radius: 10px;
  }
  .image{
    width: 100%;
    height: 100%;
    background-size:cover;
  }
  .image .v-image__image--contain{
    width: 100% !important;
    height: 100% !important;
    background-size:cover;
  } 
  .list-type-disk{
    list-style-type: disc;
  }
  .list-type-none{
    list-style-type: none;
    padding-left: 0px !important;
  }
  .content-header{
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
  }
  .sides-title{
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
  }
  .item-defects{
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
  }
  .match-head{
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
  }
  .no_data{
    text-align: center;
    color: #00000061;
  }
  .item-card{
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    border-radius: 4px;
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
  .na-style{
    font-size: 12px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/api/v1/Aireports/reportitemdetails.vue